export default "assets/images/icons/print-d41e9483.svg";